import apiRequest from "../../functions/api";

export const postAufgabeErledigen = (accessToken, hvktKey) => {
  return new Promise((resolve, reject) => {
    const payload = {
      statement: "AUFGABE_ERLEDIGEN",
      aufgabe: hvktKey,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest(
      "POST",
      "aufgaben",
      payload,
      headers,
      (response) => {
        if (response.status === 200) {
          const data = {
            aufgaben: [],
            erinnerungen: [],
            anzahlErinnerungen: 0,
          };
          if (response.data.aufgaben) {
            data.aufgaben = response.data.aufgaben;
            data.anzahlErinnerungen = response.data.erinn_zaehler;
            if (data.anzahlErinnerungen !== "0")
              data.erinnerungen = response.data.erinn;
            if (response.data.aufgabenCount)
              data.aufgabenCount = response.data.aufgabenCount;
          }
          resolve(data);
        } else {
          if (response) {
            reject(response.data.message);
          } else {
            reject("Keine Internetverbindung");
          }
        }
        resolve();
      },
      () => {
        reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
      }
    );
  });
};
